import {fetchWithState, getFetchedJSON} from '~/misc/fetch';
import format from 'date-fns/format';

export const loadsRate = (getState, data) => {
	return fetchWithState(getState, {
		url: '/v1/search/loads/rate',
		method: 'POST',
		body: {
			pickup: data.pickup,
			drop_off: data.drop_off,
			equipment: data.equipment.toLocaleLowerCase(),
			interval: data.interval,
		},
	}, false).then(getFetchedJSON);
}
export const fuelPrice = (getState, data) => {
	return fetchWithState(getState, {
		url: '/v1/search/fuel/rate',
		method: 'POST',
		body: {
			longitude1: data.fromLng,
			latitude1: data.fromLat,
			longitude2: data.toLng,
			latitude2: data.toLat,
		}
	}, false).then(getFetchedJSON);
}
export const loadsCount = (getState, data) => {
	return fetchWithState(getState, {
		url: '/v1/search/loads/count',
		method: 'POST',
		body: {
			pickup: data.pickup,
			drop_off: data.drop_off,
			equipment: data.equipment.toLocaleLowerCase(),
			deadhead: data.deadhead,
		},
	}, false).then(getFetchedJSON);
}
export const trucksCount = (getState, data) => {
	return fetchWithState(getState, {
		url: '/v1/search/trucks/count',
		method: 'POST',
		body: {
			longitude1: data.fromLng,
			latitude1: data.fromLat,
			longitude2: data.toLng,
			latitude2: data.toLat,
			max_deadhead: data.maxDeadhead,
			trailer_type: data.trailerType.toLocaleLowerCase(),
			pick_date: format(new Date(), 'YYYY-MM-DDThh:mm:ssZ'),
		},
	}, false).then(getFetchedJSON);
}

export const getRateSwitchApi = (getState) => fetchWithState(getState, {
  method: 'GET',
  url: '/tl/window/conf?key=tool_window',
}).then(getFetchedJSON);


export const getSingleRate = (getState, {equipment, from, to}) => fetchWithState(getState, {
  method: 'POST',
  url: '/tl/shipment/rate/trend',
	body: {
		equipment,
    pickupState: from,
    dropOffStates: to
	}
}).then(getFetchedJSON);


// WEBPACK FOOTER //
// ./src/api/rate.js